import {
    InteractionType,
    LogLevel,
    Configuration,
    BrowserCacheLocation,
    IPublicClientApplication,
    PublicClientApplication
} from '@azure/msal-browser';
import {
    MsalGuardConfiguration,
    MsalInterceptorConfiguration
} from '@azure/msal-angular';
import { environment } from '../environments/environment';

export const msalConfig: Configuration = {
    auth: {
        clientId: environment.adminToolClientId,
        authority: `https://login.microsoftonline.com/${environment.adminToolTenentId}`,
        redirectUri: '/', //You must register this URI on Azure portal/App Registration.
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: true,
        clientCapabilities: ['CP1'] // This lets the resource server know that this client can handle claim challenges.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
        loggerOptions: {
            loggerCallback(_logLevel: LogLevel, message: string) {
                if (!environment.production) {
                    console.log(message);
                }
            },
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false
        }
    }
};

export const apiScopes = [
    `api://${environment.adminToolApiClientId}/access_as_user`
];

export const loginRequest = {
    scopes: ['openid', 'profile']
};

export const roles = {
    AdminToolReader: 'GOH.AdminTool.Reader',
    AdminToolSupport: 'GOH.AdminTool.Support',
    AdminToolOnboarder: 'GOH.AdminTool.Onboarder',
    AdminToolAdmin: 'GOH.AdminTool.Admin',
    AdminToolSuperUser: 'GOH.AdminTool.SuperUser'
} as const;

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: loginRequest
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map<string, string[]>([
            [environment.apiBaseV1, [...apiScopes]],
            [environment.apiBaseV2, [...apiScopes]],
        ])
    };
}

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(msalConfig);
}